import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import ListCreator from '../../components/Lists/listCreator'
import { getCall } from '../helpers/componentApiHelpers/getCall'
import '../main.css'

class BitkiSekilleriList extends Component {

    constructor(props){
        super(props)
        this.state = {
            data: "",
            dataCame: false
        }
    }

    async componentDidMount() {
        try{
            const getData = await getCall("/plantShape/getall")
            await this.setState({dataCame: true, data: getData.data})
        }
        catch(err){
            console.log(err)
        }
    }

    render() {

        return (
            <React.Fragment>
                <HeaderLine header="Bitki Şekilleri" />
                <button onClick={() => this.props.history.push("/bitkiSekilleriCreate")} className="blue-button add-new-button">Yeni Ekle</button>
                <ListCreator
                    data={this.state.data}
                    dataInfo={[
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "typeName", header: "Bitki Çeşidi" },
                        { className: "col-6 col-md-3 col-sm-6 col-lg-3", objectPropName: "image", header: "Resim" },
                    ]}
                    buttons={{
                        className: "col-2",
                        buttonData: [
                            { name: "Düzenle", func: (d) => {this.props.history.push("/bitkiSekilleriCreate/" + d._id)} },
                            { name: "Detay", func: (d) => {this.props.history.push("detay/bitkiSekilleriDetay/" + d._id)} },
                            { name: "Sil" }
                        ]
                    }}
                    dataCame={this.state.dataCame}
                    endPoint="/plantShape"
                />
            </React.Fragment>
        )
    }
}

export default BitkiSekilleriList